import '../components/layout/layout';

((window) => {
  const loadCss = () => {
    Array.prototype.forEach.call(document.querySelectorAll('meta[name="css:lazyload"]'), (element) => {
      const content = element.getAttribute('content');
      const parent = element.parentElement || element.parentNode;
      window.loadCSS(content);
      parent.removeChild(element);
    });
  };
  loadCss();
})(window);
